const STATS = [
  { value: "0-24", label: "Nonstop ügyelet" },
  { value: "60'", label: "Kiérkezés max." },
  { value: "3000+", label: "Megjavított defekt" },
  { value: "0 Ft", label: "Rejtett költség" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="relative border-y border-gray-200 bg-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-200">
        {STATS.map((s, i) => (
          <div key={i} className="px-4 md:px-8 first:pl-0">
            <div className="font-display text-3xl md:text-5xl font-black bg-gradient-to-br from-gray-900 to-violet-600 bg-clip-text text-transparent leading-none">
              {s.value}
            </div>
            <div className="mt-2 text-[11px] md:text-xs uppercase tracking-[0.2em] text-gray-400">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
